import { render, staticRenderFns } from "./DepartmentRatingEdit.vue?vue&type=template&id=6908d496&"
import script from "./DepartmentRatingEdit.vue?vue&type=script&lang=js&"
export * from "./DepartmentRatingEdit.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentRatingEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports